<template>
  <div>
    <el-upload
      :multiple="multiple"
      :show-file-list="false"
      drag
      action
      :disabled="disabled"
      :accept="accept"
      :before-upload="beforeAvatarUpload"
      :http-request="uploadRequest">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div class="el-upload__tip"
           slot="tip">只能上传gif/jpg/png文件，且不超过2048kb
      </div>
    </el-upload>
    <ul class="image-list">
      <li style="display: inline-block;width: 87px;height: 87px;"
          v-for="(url, index) in value"
          :key="url">
        <div class="image-drop-shadow">
          <img
            @click="viewImage"
            :data-url="url|ossHost"
            :src="url|ossThumbnail(75, 'FFFFFF')"
            :alt="url|baseName"/>
          <span class="el-upload-list__item-actions">
            <span class="el-upload-list__item-preview">
              <i class="el-icon-zoom-in"
                 @click="onView"></i>
            </span>
            <span class="el-upload-list__item-delete">
              <i class="el-icon-delete"
                 @click="$emit('remove', index)"></i>
            </span>
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'viewerjs'

export default {
  components: {},
  props: {
    value: {
      type: Array,
      default: [],
    },
    multiple: Boolean,
    disabled: Boolean,
    httpRequest: Function,
    name: {
      type: String,
      default: 'file',
    },
    accept: {
      type: String,
      default: 'image/gif,image/jpeg,image/png,image/gif',
    },
  },
  data () {
    return {
      views: {},
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    uploadRequest (obj) {
      let formData = new FormData()
      formData.append(this.name, obj.file)
      this.httpRequest(formData)
    },
    onView (event) {
      $(event.target).parent().parent().prev().click()
    },
    viewImage (event) {
      let alt = event.target.alt
      if (!this.views[alt]) {
        this.views[alt] = new Viewer(event.target, {
          url: (image) => `${image.dataset.url}?x-oss-process=image/auto-orient,1`,
        })
      }
      this.views[alt].view()
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
ul.image-list {
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    margin: 0 10px 10px 0;
    display: inline-block;
    overflow: hidden;
    border-radius: 3px;

    .image-drop-shadow {
      padding: 5px;
      border: solid 1px #EFEFEF;
      position: relative;
    }

    img {
      display: inline-block;
      width: 75px;
      height: 75px;
    }
  }

  .el-upload-list__item-actions {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    cursor: default;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s;

    span {
      display: none;
      cursor: pointer;
    }

    span + span {
      margin-left: 15px
    }

    &:hover {
      opacity: 1;

      span {
        display: inline-block;
      }
    }

    &::after {
      display: inline-block;
      content: "";
      height: 100%;
      vertical-align: middle;
    }
  }

  .el-upload-list__item-delete {
    position: static;
    font-size: inherit;
    color: inherit;
  }
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// core/components/ImageUploadControl.vue